export const banners = [{
    id: 1,
    title: '让数字与现实世界<br/>更加透明、高效、可信！',
    isBig: true,
    desc: 'AI大数据产品及应用解决方案供应商',
    img: require('@/assets/images/banner2-0.png'),
    appImg: require('@/assets/images/banner1_app.png'),
    isVideo: false
  },
  {
    id: 2,
    title: '聚合大数据',
    desc: '让数据创造未来',
    img: require('@/assets/images/banner2-0.png'),
    appImg: require('@/assets/images/banner2_app.png')
  },
  {
    id: 3,
    title: '人工智能',
    desc: '领先的AI技术',
    img: require('@/assets/images/banner2-0.png'),
    appImg: require('@/assets/images/banner3_app.png')
  }
];

export const moduleCard = [{
    title: '品牌营销',
    desc: '帮助商家完成品牌展示、引流获客与营销转化等需求，构建品牌营销闭环',
    img: require('@/assets/images/moduleCard1.png')
  },
  {
    title: '商业变现',
    desc: '帮助商家完成开店、知识产品交付及变现需求，打造商业变现闭环',
    img: require('@/assets/images/moduleCard2.png')
  },
  {
    title: '用户运营',
    desc: '帮助商家完成用户触达管理及沉淀私域流量需求，构建用户运营闭环',
    img: require('@/assets/images/moduleCard3.png')
  }
];

export const moduleLink = [{
  title: '获客转化',
  child: [{
    name: '经营场景',
    desc: '全渠道经营开店，占据流量入口',
    img: require('@/assets/images/link1.png')
  }, {
    name: '裂变引流',
    desc: '多种玩法，持续裂变引流获客',
    img: require('@/assets/images/link2.png')
  }, {
    name: '直播营销',
    desc: '边播边卖，高效引流和变现',
    img: require('@/assets/images/link3.png')
  }, {
    name: '转化变现',
    desc: '下单转化，刺激订单和销量',
    img: require('@/assets/images/link4.png')
  }]
}, {
  title: '产品交付',
  child: [{
    name: '直播产品',
    desc: '多样直播形式与互动课堂',
    img: require('@/assets/images/link5.png')
  }, {
    name: '知识产品',
    desc: '图文音视频、电子书、训练营',
    img: require('@/assets/images/link6.png')
  }, {
    name: '线下产品',
    desc: '解决线下教学运营管理难题',
    img: require('@/assets/images/link7.png')
  }, {
    name: '实物商品',
    desc: '课程带货、商品管理、交易订单',
    img: require('@/assets/images/link8.png')
  }]
}, {
  title: '服务交付',
  child: [{
    name: '助学服务',
    desc: '社群式助学服务满足督学需求',
    img: require('@/assets/images/link9.png')
  }, {
    name: '付费问答',
    desc: '1V1咨询服务，针对性解答疑问',
    img: require('@/assets/images/link10.png')
  }, {
    name: '测试互动',
    desc: '趣味测试活跃用户',
    img: require('@/assets/images/link11.png')
  }, {
    name: '线下服务',
    desc: '线下服务预约与实施管理',
    img: require('@/assets/images/link12.png')
  }]
}, {
  title: '用户运营',
  child: [{
    name: '信息采集',
    desc: '采集付费用户信息，构建用户画像',
    img: require('@/assets/images/link13.png')
  }, {
    name: '用户运营',
    desc: '标签分组实现针对性运营动作',
    img: require('@/assets/images/link14.png')
  }, {
    name: '群工具',
    desc: '高效、安全的群工具沟通触达',
    img: require('@/assets/images/link15.png')
  }, {
    name: '超级会员',
    desc: '搭建私域矩阵，全生命周期会员运营',
    img: require('@/assets/images/link16.png')
  }]
}];

export const modulePlan = [{
  title: '知识付费',
  desc: '让您一分钟拥有自己的知识店铺',
  img: require('@/assets/images/plan1.png')
}, {
  title: '教育培训',
  desc: '教育机构的互联网解决方案',
  img: require('@/assets/images/plan2.png')
}, {
  title: '企业培训',
  desc: '解决企业内外培训管理难题',
  img: require('@/assets/images/plan3.png')
}];

export const moduleEffect = [{
  title: '读书文化',
  img: require('@/assets/images/icon_service1.png')
}, {
  title: '财经楼市',
  img: require('@/assets/images/icon_service2.png')
}, {
  title: '养生塑形',
  img: require('@/assets/images/icon_service3.png')
}, {
  title: '情感心理',
  img: require('@/assets/images/icon_service4.png')
}, {
  title: '教培机构',
  img: require('@/assets/images/icon_service5.png')
}, {
  title: '职场技能',
  img: require('@/assets/images/icon_service6.png')
}, {
  title: '快消零售',
  img: require('@/assets/images/icon_service7.png')
}, {
  title: 'IT科技',
  img: require('@/assets/images/icon_service8.png')
}, {
  title: '管理咨询',
  img: require('@/assets/images/icon_service9.png')
}, {
  title: '旅游行业',
  img: require('@/assets/images/icon_service10.png')
}, {
  title: '金融机构',
  img: require('@/assets/images/icon_service11.png')
}, {
  title: '法律服务',
  img: require('@/assets/images/icon_service12.png')
}, {
  title: '出版传媒',
  img: require('@/assets/images/icon_service13.png')
}, {
  title: '高等教育',
  img: require('@/assets/images/icon_service14.png')
}, {
  title: '公益组织',
  img: require('@/assets/images/icon_service15.png')
}];

export const moduleChoice = [{
  title: '吴晓波频道',
  desc: '知识服务逐渐变成了有定价、有边界、服务非常清晰的产品。&ldquo;每天听见吴晓波&rdquo;在过去短短几个月内发展到十几万付费用户，和知链的使用有很大关系，它帮助我们在内容发布的过程中，完成用户的管理系统。',
  img: require('@/assets/images/company1.png')
}, {
  title: '十点读书',
  desc: '知链，自媒体人坚实的桥梁，连接好内容，连接好知识。',
  img: require('@/assets/images/company2.png')
}, {
  title: '好未来家庭教育中心',
  desc: '家庭教育的普及需要更多好内容的参与，而知识付费是一条便捷且高效率的途径。知链提供了人人可用的入门方案，使这一切变得更简单高效。家长大学的底层系统的搭建离不开知链的技术支持，让我们可以更专注于教育内容上的打磨。',
  img: require('@/assets/images/company3.png')
}, {
  title: '广发基金财富学院',
  desc: '知链帮助基金公司打破了与投资者之间的时间、空间限制，让我们的投研观点与投教内容能更高效地触达更多客户。',
  img: require('@/assets/images/company4.png')
}, {
  title: '吴晓波频道',
  desc: '知识服务逐渐变成了有定价、有边界、服务非常清晰的产品。&ldquo;每天听见吴晓波&rdquo;在过去短短几个月内发展到十几万付费用户，和知链的使用有很大关系，它帮助我们在内容发布的过程中，完成用户的管理系统。',
  img: require('@/assets/images/company5.png')
}, {
  title: '吴晓波频道',
  desc: '知识服务逐渐变成了有定价、有边界、服务非常清晰的产品。&ldquo;每天听见吴晓波&rdquo;在过去短短几个月内发展到十几万付费用户，和知链的使用有很大关系，它帮助我们在内容发布的过程中，完成用户的管理系统。',
  img: require('@/assets/images/company6.png')
}, {
  title: '吴晓波频道',
  desc: '知识服务逐渐变成了有定价、有边界、服务非常清晰的产品。&ldquo;每天听见吴晓波&rdquo;在过去短短几个月内发展到十几万付费用户，和知链的使用有很大关系，它帮助我们在内容发布的过程中，完成用户的管理系统。',
  img: require('@/assets/images/company7.png')
}, {
  title: '吴晓波频道',
  desc: '知识服务逐渐变成了有定价、有边界、服务非常清晰的产品。&ldquo;每天听见吴晓波&rdquo;在过去短短几个月内发展到十几万付费用户，和知链的使用有很大关系，它帮助我们在内容发布的过程中，完成用户的管理系统。',
  img: require('@/assets/images/company8.png')
}, {
  title: '吴晓波频道',
  desc: '知识服务逐渐变成了有定价、有边界、服务非常清晰的产品。&ldquo;每天听见吴晓波&rdquo;在过去短短几个月内发展到十几万付费用户，和知链的使用有很大关系，它帮助我们在内容发布的过程中，完成用户的管理系统。',
  img: require('@/assets/images/company9.png')
}, {
  title: '吴晓波频道',
  desc: '知识服务逐渐变成了有定价、有边界、服务非常清晰的产品。&ldquo;每天听见吴晓波&rdquo;在过去短短几个月内发展到十几万付费用户，和知链的使用有很大关系，它帮助我们在内容发布的过程中，完成用户的管理系统。',
  img: require('@/assets/images/company10.png')
}, {
  title: '吴晓波频道',
  desc: '知识服务逐渐变成了有定价、有边界、服务非常清晰的产品。&ldquo;每天听见吴晓波&rdquo;在过去短短几个月内发展到十几万付费用户，和知链的使用有很大关系，它帮助我们在内容发布的过程中，完成用户的管理系统。',
  img: require('@/assets/images/company11.png')
}];
